/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2019, 2024
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import { normalize } from 'normalizr';
import { all, call, put, takeEvery } from 'redux-saga/effects';

import * as exampleApi from '../../api/examples';
import * as intentsApi from '../../api/intents';
import * as actions from './actions';
import * as actionType from './actionTypes';
import { intentsSchema } from './schema';

export function* filterIntents({ skillId, queryString }) {
  try {
    const options = {
      export: true,
      page_limit: 100000,
      include_count: true,
      sort: 'intent'
    };
    const intents = yield call(
      intentsApi.filterIntents,
      skillId,
      options,
      queryString
    );
    yield put(actions.filterIntentsSuccess(normalize(intents, intentsSchema)));
  } catch (e) {
    yield put(actions.filterIntentsError(e.message));
  }
}

function* watchFilterIntents() {
  yield takeEvery(actionType.FILTER_INTENTS_START, filterIntents as any);
}

export function* listIntentExamples({ skillId, intentName }) {
  try {
    const examples = yield call(exampleApi.listExamples, skillId, intentName);
    yield put(actions.listIntentExamplesSuccess(examples));
  } catch (e) {
    yield put(actions.listIntentExamplesError(e.message));
  }
}

function* watchListIntentExamples() {
  yield takeEvery(
    actionType.LIST_INTENT_EXAMPLES_START,
    listIntentExamples as any
  );
}

export default function* rootSaga() {
  yield all([watchFilterIntents(), watchListIntentExamples()]);
}
